module.exports = __webpack_public_path__ + "img/corp-benefits-turnover.cdc22e64.svg";